<template>
  <div class="system-message">
    <div class="system-message__top-desc" v-if="isTopDescSlot">
      <slot name="topDescImage"></slot>
    </div>
    <div class="system-message__main-title" v-if="isMainTitleSlot">
      <slot name="mainTitleSlot"></slot>
    </div>
    <div class="system-message__subtitle" v-if="isMainSubtitleSlot">
      <slot name="mainSubtitleSlot"></slot>
    </div>
    <div class="system-message__more-desc" v-if="isDescriptionSlot">
      <slot name="descriptionSlot"></slot>
    </div>
    <div class="system-message__actions" v-if="isActionsSlot">
      <slot name="actionsSlot"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from "vue";

/**
 * Слоты
 */
const slots = useSlots();
/**
 * Верхняя картинка ли текст
 */
const isTopDescSlot = computed(() => slots && slots.topDescImage && slots.topDescImage());
/**
 * Основной заголовок
 */
const isMainTitleSlot = computed(() => slots && slots.mainTitleSlot && slots.mainTitleSlot());
/**
 * Подзаголовок
 */
const isMainSubtitleSlot = computed(
  () => slots && slots.mainSubtitleSlot && slots.mainSubtitleSlot(),
);
/**
 * Расширенное описание
 */
const isDescriptionSlot = computed(() => slots && slots.descriptionSlot && slots.descriptionSlot());
/**
 * Слот для кнопок и экшенов
 */
const isActionsSlot = computed(() => slots && slots.actionsSlot && slots.actionsSlot());
</script>

<style lang="scss">
@import "./style.scss";
</style>
